
async function init() {
    var teamGridTabs = $(document).find('[data-module-name="team-grid-tabs"]')
    if (!teamGridTabs || teamGridTabs.length < 1) {
        return;
    }

    for (let index = 0; index < teamGridTabs.length; index++) {

        var teamGridTab = $(teamGridTabs[index]);
        if (teamGridTab) {


            const filterTabs = teamGridTab.find('.filter-nav__items .filter-nav__item');
            if (filterTabs) {
                filterTabs.click(function (e) {
                    e.preventDefault();
                    var specialty = $(e.currentTarget).data('specialty');
                    var specialtyName = $(e.currentTarget).data('name');
                    var currentSpecialty = teamGridTab.find(".currentTeamTab");                
                    var currentSpecialtyData = currentSpecialty ? currentSpecialty.attr('data-currentspecialty') : "";

                    if (specialty && specialty != currentSpecialtyData) {
                        currentSpecialty.text(specialtyName);
                        currentSpecialty.attr('data-currentspecialty', specialty);                   
                        var allProviders = teamGridTab.find(".md_all");
                        var currentProviders = teamGridTab.find("." + specialty);
                        allProviders.hide();
                        currentProviders.show();
                    }

                });
            }
        }
    }
}


export default {
    init: init
}